/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@emotion/css';
import Slider from 'react-slick';
import { isEmpty } from 'lodash';
import InputListWidget from './InputListWidget';
import CheckboxWidget from './CheckboxWidget';
import RadioBtnWidget from './RadioBtnWidget';
import { SlickArrow, applyFilterBtn, filterBtn } from '../Ui';
import { mapOrder, contentAlignment } from '../../utils';

const filterWrapper = (params) => css`
  display: flex;
  flex-direction: column;
  gap: 25px;
  position: absolute;
  box-sizing: border-box;
  right: 0;
  z-index: 998;
  margin-top: 4px;
  font-weight: ${params?.fontWeight};
  font-size: ${params?.fontSize};
  color: ${params?.textColor};
  padding: ${params?.padding};
  background: ${params?.backgroundColor};
  width: 100%;
  top: 1.8em;
  ${params?.dropShadow && ('box-shadow: 1px 5px 6px -2px #000000;')}
  border-width: ${params?.borderSize};
  border-color: ${params?.borderColor};
  border-style: solid;
`;

const btnSection = (params) => css`
  display: flex;
  justify-content: ${contentAlignment(params?.resetAlign, params?.applyAlign)};
  border-top: 1px solid ${params?.textColor};
  padding: 25px 0 35px 0;
  position: relative;
  &:after {
    content: '';
    width: 42px;
    border-radius: 15px;
    height: 2px;
    position: absolute;
    left: calc(50% - 21px);
    background: ${params?.textColor};
    bottom: 0;
  }
`;

const components = {
  InputListWidget,
  CheckboxWidget,
  RadioBtnWidget,
};

const createTypeComponent = (props) => {
  const {
    typeName, filter, ...restParams
  } = props;
  const TypeName = components[typeName];

  return React.createElement(TypeName, {
    isMobile: true,
    filter,
    key: filter.key,
    ...restParams,
  });
};

const DropdownMultiMobile = ({
  filters: {
    multiSelect = [],
    gender = null,
    subscriptions = null,
  },
  filtersData = {},
  onChange,
  onReset,
  themeConfig: {
    multiDropdown,
    buttons,
  },
  themeConfig,
  isDynamic,
  hasFilterChanged,
  filterOrder,
}) => {
  const [isScrolling, setIsScrolling] = useState(false);
  const [scrollTimeout, setScrollTimeout] = useState(null);
  const filtersArr = [
    ...(multiSelect.filter((o) => o.options && o.key !== 'subscriptions')),
    ...(gender ? [gender] : []),
    ...(subscriptions ? [subscriptions] : []),
  ];
  const orderedArr = filterOrder?.length ? mapOrder(filtersArr, filterOrder, 'key') : filtersArr;
  const hasFiltersData = !isEmpty(filtersData);

  const handleScroll = () => {
    if (!isScrolling) {
      setIsScrolling(true);
    }
    clearTimeout(scrollTimeout);
    setScrollTimeout(setTimeout(() => {
      setIsScrolling(false);
    }, 200));
  };

  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    dots: false,
    swipe: !isScrolling,
    nextArrow: <SlickArrow direction="next" themeConfig={multiDropdown} />,
    prevArrow: <SlickArrow direction="prev" themeConfig={multiDropdown} />,
  };

  return (
    <div className={cx(filterWrapper(multiDropdown), multiDropdown.fontType)}>
      <Slider {...settings}>
        {orderedArr?.map((filter) => (
          createTypeComponent({
            typeName: filter.type, filter, onChange, handleScroll, hasFiltersData, themeConfig,
          })
        ))}
      </Slider>
      <div className={btnSection({
        ...multiDropdown,
        resetAlign: buttons.reset.buttonAligned,
        applyAlign: buttons.apply.buttonAligned,
      })}
      >
        {(!isDynamic && isEmpty(filtersData))
          && (
            <button
              type="button"
              disabled={!hasFilterChanged}
              onClick={onChange(false, false, true)}
              className={cx(filterBtn({ ...buttons.apply, isMobile: true }), buttons.apply.fontType,
                applyFilterBtn({
                  ...buttons.apply,
                  resetAlign: buttons.reset.buttonAligned,
                }))}
            >
              {buttons.apply.label}
            </button>
          )}
        <button
          type="button"
          className={cx(filterBtn({ ...buttons.reset, isMobile: true }, buttons.reset.fontType))}
          onClick={onReset}
        >
          {buttons.reset.label}
        </button>
      </div>
    </div>
  );
};

DropdownMultiMobile.propTypes = {
  isDynamic: PropTypes.bool,
  onChange: PropTypes.func,
  onReset: PropTypes.func,
  filters: PropTypes.object,
  filtersData: PropTypes.object,
  hasFilterChanged: PropTypes.bool,
  themeConfig: PropTypes.object,
  filterOrder: PropTypes.array,
};

export default DropdownMultiMobile;
